/** When your routing table is too long, you can split it into small modules **/

const paymentRouter = [

]


export default paymentRouter
